/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    CarbonEmissionIntensityDto,
    DailyCarbonEmissionEstimate,
    TotalEmissionEstimateResponse,
} from "../models/index";
import {
    CarbonEmissionIntensityDtoFromJSON,
    CarbonEmissionIntensityDtoToJSON,
    DailyCarbonEmissionEstimateFromJSON,
    DailyCarbonEmissionEstimateToJSON,
    TotalEmissionEstimateResponseFromJSON,
    TotalEmissionEstimateResponseToJSON,
} from "../models/index";

export interface DeviceGroupDailyCarbonEmissionRequest {
    deviceGroupTag: string;
    scopeFactorTypes: Array<DeviceGroupDailyCarbonEmissionScopeFactorTypesEnum>;
    from?: string;
    to?: string;
}

export interface GetTotalCarbonEmissionsEstimateValueRequest {
    from: string;
    to: string;
    scopeFactorTypes: Array<GetTotalCarbonEmissionsEstimateValueScopeFactorTypesEnum>;
    deviceGroupTag?: Array<string>;
    inLocalTime?: boolean;
}

/**
 *
 */
export class SustainabilityDashboardHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get daily emission metrics for device groups with type of Site or Organisation. Will default to last 30 days if date range not specified.
     */
    async deviceGroupDailyCarbonEmissionRaw(
        requestParameters: DeviceGroupDailyCarbonEmissionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DailyCarbonEmissionEstimate>>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupDailyCarbonEmission().',
            );
        }

        if (requestParameters["scopeFactorTypes"] == null) {
            throw new runtime.RequiredError(
                "scopeFactorTypes",
                'Required parameter "scopeFactorTypes" was null or undefined when calling deviceGroupDailyCarbonEmission().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["scopeFactorTypes"] != null) {
            queryParameters["scopeFactorTypes"] = requestParameters[
                "scopeFactorTypes"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/sustainability-dashboard/carbon-emission-daily/{deviceGroupTag}`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DailyCarbonEmissionEstimateFromJSON),
        );
    }

    /**
     * Get daily emission metrics for device groups with type of Site or Organisation. Will default to last 30 days if date range not specified.
     */
    async deviceGroupDailyCarbonEmission(
        requestParameters: DeviceGroupDailyCarbonEmissionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DailyCarbonEmissionEstimate>> {
        const response = await this.deviceGroupDailyCarbonEmissionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Lookup fields for Carbon Intensity Values. Returns state code/national and CO2/kWh.
     */
    async getCarbonIntensityValuesRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<CarbonEmissionIntensityDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/sustainability-dashboard/carbon-intensity-values`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(CarbonEmissionIntensityDtoFromJSON),
        );
    }

    /**
     * Lookup fields for Carbon Intensity Values. Returns state code/national and CO2/kWh.
     */
    async getCarbonIntensityValues(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<CarbonEmissionIntensityDto>> {
        const response = await this.getCarbonIntensityValuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Total carbon emission estimate value per state/country for a time period, for the requested device groups. Also includes percentage diff with the immediately preceding period.
     */
    async getTotalCarbonEmissionsEstimateValueRaw(
        requestParameters: GetTotalCarbonEmissionsEstimateValueRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<TotalEmissionEstimateResponse>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getTotalCarbonEmissionsEstimateValue().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getTotalCarbonEmissionsEstimateValue().',
            );
        }

        if (requestParameters["scopeFactorTypes"] == null) {
            throw new runtime.RequiredError(
                "scopeFactorTypes",
                'Required parameter "scopeFactorTypes" was null or undefined when calling getTotalCarbonEmissionsEstimateValue().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTag"] != null) {
            queryParameters["deviceGroupTag"] = requestParameters[
                "deviceGroupTag"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters["inLocalTime"] != null) {
            queryParameters["inLocalTime"] = requestParameters["inLocalTime"];
        }

        if (requestParameters["scopeFactorTypes"] != null) {
            queryParameters["scopeFactorTypes"] = requestParameters[
                "scopeFactorTypes"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/sustainability-dashboard/total-carbon-emissions-value`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            TotalEmissionEstimateResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get Total carbon emission estimate value per state/country for a time period, for the requested device groups. Also includes percentage diff with the immediately preceding period.
     */
    async getTotalCarbonEmissionsEstimateValue(
        requestParameters: GetTotalCarbonEmissionsEstimateValueRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<TotalEmissionEstimateResponse> {
        const response = await this.getTotalCarbonEmissionsEstimateValueRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}

/**
 * @export
 */
export const DeviceGroupDailyCarbonEmissionScopeFactorTypesEnum = {
    Scope1: "scope1",
    Scope2: "scope2",
    Scope3: "scope3",
} as const;
export type DeviceGroupDailyCarbonEmissionScopeFactorTypesEnum =
    (typeof DeviceGroupDailyCarbonEmissionScopeFactorTypesEnum)[keyof typeof DeviceGroupDailyCarbonEmissionScopeFactorTypesEnum];
/**
 * @export
 */
export const GetTotalCarbonEmissionsEstimateValueScopeFactorTypesEnum = {
    Scope1: "scope1",
    Scope2: "scope2",
    Scope3: "scope3",
} as const;
export type GetTotalCarbonEmissionsEstimateValueScopeFactorTypesEnum =
    (typeof GetTotalCarbonEmissionsEstimateValueScopeFactorTypesEnum)[keyof typeof GetTotalCarbonEmissionsEstimateValueScopeFactorTypesEnum];
